<template>
  <div class="card" v-show="isSection('best3')">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>BEST3</h2>
      </div>
      <div class="card-content-list myprofile-best3-grid">
        <div class="myprofile-best3-col">
          <p class="myprofile-best3-title">趣味 BEST3</p>
          <div class="myprofile-form-group" v-for="n in 3" :key="'hobby-' + n">
            <label class="myprofile-label">趣味{{ n }}</label>
            <el-input
              :value="hobbyItem(n - 1)"
              :placeholder="'趣味' + n"
              @input="(val) => setHobby(n - 1, val)"
            />
          </div>
        </div>
        <div class="myprofile-best3-col">
          <p class="myprofile-best3-title">特技 BEST3</p>
          <div class="myprofile-form-group" v-for="n in 3" :key="'skill-' + n">
            <label class="myprofile-label">特技{{ n }}</label>
            <el-input
              :value="skillItem(n - 1)"
              :placeholder="'特技' + n"
              @input="(val) => setSkill(n - 1, val)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import { isCardSectionActive } from '@/utils/format-edit/cardSections'
import {
  setStringListItem,
  stringListItem
} from '@/utils/format-edit/myprofileFields'

const props = defineProps<{
  currentCardId?: string
  formatId?: string
}>()

const formatData = useRirekishoFormatData()

const isSection = (section: string) =>
  isCardSectionActive(props.formatId, props.currentCardId, section)

function hobbyItem(idx: number) {
  return stringListItem(formatData.hobbies, idx)
}

function setHobby(idx: number, val: string) {
  setStringListItem(formatData, 'hobbies', idx, val, 3)
}

function skillItem(idx: number) {
  return stringListItem(formatData.skills, idx)
}

function setSkill(idx: number, val: string) {
  setStringListItem(formatData, 'skills', idx, val, 3)
}
</script>

<style lang="scss" scoped>
.myprofile-form-group {
  margin-bottom: 16px;

  .myprofile-label {
    display: block;
    font-size: 13px;
    color: #555;
    margin-bottom: 4px;
    font-weight: bold;
  }
}

.myprofile-best3-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 16px;
}

@media (width <= 768px) {
  .myprofile-best3-grid {
    grid-template-columns: 1fr;
  }
}

.myprofile-best3-title {
  font-size: 15px;
  font-weight: bold;
  margin: 8px 0 12px;
  padding-bottom: 4px;
  border-bottom: 2px solid #e6f7f3;
}
</style>
